var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 699 188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#fff;} .cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:7px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.56,521.28l5-2.94c2.62,9.15,10.35,15.36,22.88,15.36,12.75,0,19.18-6.54,19.18-15.25,0-9.15-8.06-12.64-19.72-16.34-12.75-4.14-24.19-7.74-24.19-21,0-12.53,10.13-20.48,23.1-20.48,12.53,0,20.81,7.19,24.52,16l-4.9,2.72c-2.83-6.86-8.72-13.18-19.61-13.18-10.57,0-17.22,6.21-17.22,14.71,0,9.15,7.74,12,18.63,15.58,13.51,4.47,25.28,8.72,25.28,21.9,0,12.64-9.92,20.92-25.06,20.92C226.18,539.26,216,532.07,212.56,521.28Z",
    transform: "translate(-151.36 -405.92)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.58,512.56V461.78h5.77v50.78c0,12.42,7.74,21.14,22.12,21.14s22.23-8.72,22.23-21.14V461.78h5.77v50.78c0,16.13-11.22,26.7-28,26.7S278.58,528.69,278.58,512.56Z",
    transform: "translate(-151.36 -405.92)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M402,485.43c0,13.4-10,23.54-23.75,23.54H358.12v29.09h-5.77V461.78h25.93C392,461.78,402,471.92,402,485.43Zm-5.77,0c0-10.57-7.52-18.2-18-18.2H358.12v36.28h20.16C388.74,503.52,396.26,495.89,396.26,485.43Z",
    transform: "translate(-151.36 -405.92)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M460.22,532.61v5.45H416.3V461.78h43.37v5.45H422.08v29.64h34.87v5.45H422.08v30.29Z",
    transform: "translate(-151.36 -405.92)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M504.23,506.79H480.15v31.27h-5.77V461.78h30.07A22.49,22.49,0,0,1,510.23,506l19,32h-6.65Zm-24.08-5.45h24.3a17.05,17.05,0,0,0,0-34.11h-24.3Z",
    transform: "translate(-151.36 -405.92)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M565.68,521.28l5-2.94c2.62,9.15,10.35,15.36,22.88,15.36,12.75,0,19.18-6.54,19.18-15.25,0-9.15-8.06-12.64-19.72-16.34-12.75-4.14-24.19-7.74-24.19-21,0-12.53,10.13-20.48,23.1-20.48,12.53,0,20.81,7.19,24.52,16l-4.9,2.72c-2.83-6.86-8.72-13.18-19.61-13.18-10.57,0-17.22,6.21-17.22,14.71,0,9.15,7.74,12,18.63,15.58,13.51,4.47,25.28,8.72,25.28,21.9,0,12.64-9.92,20.92-25.06,20.92C579.3,539.26,569.17,532.07,565.68,521.28Z",
    transform: "translate(-151.36 -405.92)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M701.23,538.06h-5.78V470.28l-28.22,46.85h-1L638,470.28v67.77h-5.78V461.78h7.19l27.24,45.11,27.24-45.11h7.3Z",
    transform: "translate(-151.36 -405.92)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M789.16,538.06h-5.78V470.28l-28.22,46.85h-1L726,470.28v67.77h-5.78V461.78h7.19l27.24,45.11,27.24-45.11h7.3Z",
    transform: "translate(-151.36 -405.92)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.5,
    y: 3.5,
    width: 692,
    height: 181
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3bf4141da2422f8db416f0600a1e8bdc.svg";
export { ForwardRef as ReactComponent };